module.exports = __webpack_public_path__ + "static/img/shiye_img8@2x.ee28ff80.jpg";